import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import routes from "./routes";
import { setPageTitle } from "../utils/helpers";

const router = new VueRouter({
  mode: "history",
  routes: routes,
  path: "*",
  redirect: "/",
});

// Admin routes declare a static `meta.title`; pages with a loaded entity
// (proof, contact, job, ...) refine it via setPageTitle once data arrives.
router.afterEach((to) => {
  setPageTitle(to.meta && to.meta.title ? to.meta.title : "");
});

export default router;
